// William Lane Estate - Direct Estate Marketing Platform
// Phase 2: Repositioned as DIRECT ESTATE MARKETING (not realtor-branded)

// W Crest brand mark URL (user-provided asset - PNG with transparent background)
export const brandAssets = {
  // Using the user's actual William Lane Icon PNG with transparent background
  wCrest: "https://customer-assets-wrfwihn1.emergentagent.net/job_87f23aec-b533-429b-b4b5-7bb9c4fa5cd4/artifacts/z8xh9829_William%20Lane%20Icon.png",
  marketVideoUrl: "https://customer-assets-wrfwihn1.emergentagent.net/job_87f23aec-b533-429b-b4b5-7bb9c4fa5cd4/artifacts/5ep4oprm_Market%20Video%20-%20audio%20level%20A.mp4"
};

// Specific section images (user-uploaded)
export const sectionImages = {
  birdsEye1: "https://customer-assets-wrfwihn1.emergentagent.net/job_87f23aec-b533-429b-b4b5-7bb9c4fa5cd4/artifacts/zrz2xwq5_BirdsEye-1.jpg",
  birdsEye2: "https://customer-assets-wrfwihn1.emergentagent.net/job_87f23aec-b533-429b-b4b5-7bb9c4fa5cd4/artifacts/93p0mzmj_BirdsEye-2.jpg",
  executiveWorkshopInterior: "https://customer-assets-wrfwihn1.emergentagent.net/job_87f23aec-b533-429b-b4b5-7bb9c4fa5cd4/artifacts/96upclzt_Executive%20Workshop-%20Interior.jpg",
  conditionedSteelBuilding: "https://customer-assets-wrfwihn1.emergentagent.net/job_87f23aec-b533-429b-b4b5-7bb9c4fa5cd4/artifacts/fy6mh8ge_Conditioned%20Steel%20Building.jpg",
  barnComplex: "https://customer-assets-wrfwihn1.emergentagent.net/job_87f23aec-b533-429b-b4b5-7bb9c4fa5cd4/artifacts/wuzsgsmk_Barn%20Complex.jpg",
  saunaBungalow: "https://customer-assets-wrfwihn1.emergentagent.net/job_87f23aec-b533-429b-b4b5-7bb9c4fa5cd4/artifacts/ray631ns_Sauna%20Bungalow.jpg",
  storageBuilding: "/images/storage-building-new.jpg"
};

export const propertyData = {
  // Brand Identity
  brandName: "William Lane Estate",
  brandTagline: "Central Florida Legacy Property",
  
  // Property Address
  address: "35126 William Lane, Eustis, FL 32736",
  
  // Updated Price: $2,300,000
  price: 2300000,
  priceFormatted: "$2,300,000",
  priceShort: "$2.3M",
  pricePerAcre: 115000, // $2,300,000 / 20 acres = $115,000/acre
  pricePerAcreFormatted: "$115,000",
  
  // Primary Headlines
  heroHeadline: "WHAT IF YOUR NEXT PROPERTY WASN'T SIMPLY ANOTHER HOME?",
  heroSubheadline: "An established Central Florida estate platform combining land, privacy, family flexibility, business-support infrastructure, agricultural capability and resilience — within reach of Orlando and two major airports.",
  
  // Core Positioning
  positioning: "THIS IS NOT SIMPLY A HOME ON ACREAGE. IT IS AN ESTABLISHED 20-ACRE CENTRAL FLORIDA LEGACY ESTATE PLATFORM.",
  visionQuestion: "WHAT COULD YOU BUILD FROM WHAT IS ALREADY HERE?",
  
  // Key Stats
  keyStats: {
    acres: 20,
    structures: 6,
    gated: true,
    noHOA: true,
    toOrlando: "45 min",
    toMCO: "45 min",
    toSanford: "25 min"
  },
  
  keyFeatures: {
    beds: 4,
    baths: 4,
    kitchens: 2,
    sqft: "3,588",
    totalSqft: "5,536",
    acres: 20,
    yearBuilt: 1999,
  },
  
  // Main Residence
  mainResidence: {
    title: "The Main Residence",
    subtitle: "Multi-generational by design. Move-in ready.",
    sqft: "3,588",
    beds: 4,
    baths: 4,
    kitchens: 2,
    features: [
      "Two Full Kitchens — Multi-generational living day one",
      "First-Floor Primary Suite with resort-style lanai views",
      "Newer metal roof system",
      "Dual tankless water heater systems",
      "24KW whole-home Generac generator with propane",
      "Premium mechanicals throughout — no deferred maintenance",
      "Enclosed resort-style lanai with outdoor cooking station",
      "Panoramic pasture views from living spaces",
      "Classic wraparound Southern porch",
      "Upstairs office with inspiring views",
      "Engineered hardwood and luxury vinyl flooring",
      "Vaulted ceilings and open floor plan"
    ]
  },
  
  // The Complete Value Stack
  valueStack: [
    {
      category: "Land & Privacy",
      data: "20 acres, county-zoned, no HOA, ag-tax",
      value: "Complete freedom. Land is finite near Orlando."
    },
    {
      category: "Main Residence",
      data: "~3,588 sq ft, 4 bed, 4 bath, 1st-floor primary",
      value: "Move-in ready, multi-generational."
    },
    {
      category: "Two Full Kitchens",
      data: "Updated primary + second kitchen",
      value: "Multi-gen living day one. No renovation required."
    },
    {
      category: "Conditioned Steel Building",
      data: "56'×28' conditioned, office + bath",
      value: "Business HQ, studio, guest quarters."
    },
    {
      category: "Executive Workshop",
      data: "35'×48', mechanical car lift + bath",
      value: "Collector/contractor ready."
    },
    {
      category: "Storage Building",
      data: "15'×30' dedicated",
      value: "No-HOA storage capacity."
    },
    {
      category: "Wellness & Hospitality",
      data: "Sauna bungalow + treehouse suite",
      value: "Amenities already built."
    },
    {
      category: "Barn & Pasture",
      data: "Stalls, coop, round pen, 3 fenced pastures",
      value: "Equestrian/homestead day one."
    },
    {
      category: "Premium Mechanicals",
      data: "Metal roof, generator, tankless, propane",
      value: "Preparedness systems included."
    },
    {
      category: "Expansion Rights",
      data: "~1 residence per 5 acres",
      value: "Compound, enclave, or heirs' estate. Subject to applicable Lake County approvals."
    }
  ],
  
  // Estate Structures
  estateStructures: [
    {
      name: "Conditioned Steel Building",
      size: "56' × 28'",
      features: ["Fully conditioned climate control", "Executive office space", "Full bathroom", "Business HQ or guest quarters ready"]
    },
    {
      name: "Executive Workshop",
      size: "35' × 48'",
      features: ["Professional-grade mechanical car lift", "Full air compressor & lines", "Full bathroom", "Collector/contractor ready from day one"]
    },
    {
      name: "Storage Building",
      size: "15' × 30'",
      features: ["Dedicated equipment storage", "No-HOA storage capacity", "RV potential", "Zero restrictions on use"]
    },
    {
      name: "Sauna Bungalow",
      size: "Private wellness retreat",
      features: ["Standalone cedar sauna", "Shower facilities", "Full bathroom", "Wellness amenity most estates add later"]
    },
    {
      name: "Treehouse Suite",
      size: "Elevated destination",
      features: ["Elevated among the trees", "Full bathroom", "Guest retreat", "Private escape or hospitality space"]
    },
    {
      name: "Barn Complex",
      size: "Full equestrian infrastructure",
      features: ["Horse stalls and round pen", "Three fenced pastures", "Chicken coops and goat pens", "Turnkey hobby farm system"]
    }
  ],
  
  // Resilience & Preparedness
  resilienceFeatures: [
    {
      title: "Established Well Water",
      description: "Private water supply independent of municipal systems"
    },
    {
      title: "Whole-Home Water Filtration & Treatment",
      description: "Comprehensive water purification throughout the residence"
    },
    {
      title: "Whole-Home Propane Generac Generator",
      description: "24KW backup power system for complete home coverage"
    },
    {
      title: "Newer Metal Roofing System",
      description: "Durable, long-lasting protection with exceptional longevity"
    }
  ],
  
  // Market Comparison / Exceptional Value
  marketComparison: {
    currentOffering: 2300000,
    comparableRange: { min: 3150000, max: 3295000 },
    savings: "Up to nearly $1 million below the closest identified improved acreage substitution range",
    disclaimer: "Active-listing research comparison; not an appraisal.",
    scarcityStatement: "Independent research across Florida's major airport-served metro markets did not identify a near-price alternative reproducing William Lane's complete combination of acreage, infrastructure, privacy, flexibility and metro/airport access.",
    priceAnalysis: {
      pricePerSqFtLand: "$2.58",
      impliedHomeCostPerSqFt: "$265",
      infrastructureValue: "$500K–$675K",
      replacementValue: "$2.7M–$3.2M minimum"
    }
  },
  
  // Expansion Capability
  expansionCapability: {
    title: "Multi-Residence Expansion Potential",
    description: "Supports build rights at approximately one full residence per five acres, enabling a luxury family compound, corporate retreat, or hospitality-ready layout.",
    disclaimer: "Potential, subject to applicable Lake County approvals and buyer due diligence.",
    useCases: [
      { title: "Luxury Family Compound", description: "Create a private enclave for multiple generations" },
      { title: "Corporate Retreat Property", description: "Premium venue for executive gatherings" },
      { title: "Heir-Placement Strategy", description: "Establish legacy properties for future generations" },
      { title: "Hospitality-Ready Layout", description: "Develop a boutique lodging destination" },
      { title: "Equestrian Estate", description: "World-class equestrian facilities with agriculture" },
      { title: "Collector's Paradise", description: "Secure storage for vehicles, art, or collections" }
    ]
  },
  
  // Relocation & Migration Data
  relocationData: {
    headline: "THE BUYER POOL IS ALREADY ARRIVING",
    subheadline: "COASTAL CAPITAL CONVERTS HERE.",
    description: "In many high-cost markets, several million dollars can be absorbed by a single residence on limited land. At William Lane, capital can be converted into acreage, privacy, infrastructure, flexibility and legacy.",
    stats: [
      { value: "~393,000", label: "Out-of-state Florida driver-license exchanges in 2025", source: "Florida DHSMV" },
      { value: "+$20.6B", label: "Net AGI gained by Florida through interstate taxpayer migration", source: "Latest IRS data" },
      { value: "~66%", label: "Orlando-region net migration since 2020 flowing toward Lake and Osceola Counties", source: "Census estimates" },
      { value: "~75%", label: "During 2025 where supported by supplied source", source: "Regional analysis" }
    ],
    targetBuyers: [
      "Executives relocating from high-tax states",
      "Entrepreneurs seeking operational flexibility",
      "Business owners requiring infrastructure",
      "High-equity homeowners converting coastal capital",
      "Multigenerational families seeking compound living"
    ]
  },
  
  // Location Intelligence
  location: {
    headline: "PRIVACY WITHOUT ISOLATION",
    subheadline: "CENTRAL FLORIDA ACCESS WITHOUT CENTRAL FLORIDA DENSITY",
    description: "Strategically positioned for unmatched connectivity while maintaining complete privacy and seclusion.",
    destinations: [
      { name: "Historic Downtown Eustis (dining, shopping, medical)", time: "~10 min" },
      { name: "Mount Dora (boutiques, waterfront dining)", time: "~10–15 min" },
      { name: "Harris Chain of Lakes (Florida's finest freshwater boating)", time: "~10–15 min" },
      { name: "I-4 Corridor (Florida's major highway access)", time: "~20 min" },
      { name: "AdventHealth Hospitals & Medical Offices", time: "~20 min" },
      { name: "Sanford International Airport", time: "~25 min" },
      { name: "Multiple Local Florida Fresh Springs", time: "~25 min" },
      { name: "Orlando International Airport (MCO)", time: "~45–50 min" },
      { name: "Downtown Metro Orlando", time: "~45–50 min" },
      { name: "Universal & SeaWorld", time: "~45–50 min" },
      { name: "Daytona Speedway & Atlantic Beaches", time: "~50–60 min" }
    ],
    disclaimer: "All drive times are approximate and may vary based on traffic conditions."
  },
  
  // Target Buyer Profiles
  idealBuyers: [
    {
      profile: "Out-of-State Relocation (UHNW)",
      benefit: "Florida lifestyle, tax advantage, privacy, and land"
    },
    {
      profile: "Multi-Generational Family",
      benefit: "Separate living zones, two kitchens, compound living"
    },
    {
      profile: "Business Owner / Collector",
      benefit: "Workshop, car lift, storage — operational from day one"
    },
    {
      profile: "Equestrian / Homesteader",
      benefit: "Turnkey barn, pasture, fencing on ag-zoned land"
    },
    {
      profile: "Retreat / Wellness Buyer",
      benefit: "Private gathering space, lodging, outdoor amenities near Orlando"
    },
    {
      profile: "Tax-Advantaged Investor",
      benefit: "Tangible, appreciating, tax-advantaged Central Florida asset"
    }
  ],
  
  // Direct Estate Contact (NO REALTOR)
  estateContact: {
    email: "TheMarketSource@Gmail.com",
    website: "centralflorida20acres.estate",
    inquiryTypes: [
      "Request Private Estate Information",
      "Buyer / Broker Inquiry",
      "Request Broker Package",
      "Ask About the Estate",
      "Discuss the Opportunity"
    ]
  },
  
  // YouTube Video IDs for embedded players
  heroYouTubeId: "4W8N9rBxJ54",
  marketYouTubeId: "LirmZjPPO_4",
  droneYouTubeId: "n1r0ukMiJoA",
  
  // Legacy video URLs (kept for reference, now using YouTube)
  heroVideoUrl: "/videos/hero_compressed.mp4",
  heroVideoHls: "/videos/hls/hero/playlist.m3u8",
  
  // Market Video URLs - Now using YouTube
  marketVideoUrl: "/videos/market_compressed.mp4",
  marketVideoHls: "/videos/hls/market/playlist.m3u8",
  
  // Virtual Tour - Now using YouTube drone video
  virtualTourUrl: "https://media.devoredesign.com/videos/0198ec8a-8e99-7176-801a-77d8c073f650?v=209",
  
  // Images - REMOVED images 62-74 as requested
  images: {
    hero: "https://bt-photos.global.ssl.fastly.net/mfr/orig_boomver_3_G5101068-1.jpg",
    aerial: "https://bt-photos.global.ssl.fastly.net/mfr/orig_boomver_3_G5101068-2.jpg",
    gallery: [
      // Images 1-61 (keeping these)
      "https://bt-photos.global.ssl.fastly.net/mfr/orig_boomver_3_G5101068-1.jpg",
      "https://bt-photos.global.ssl.fastly.net/mfr/orig_boomver_3_G5101068-2.jpg",
      "https://bt-photos.global.ssl.fastly.net/mfr/orig_boomver_2_G5101068-3.jpg",
      "https://bt-photos.global.ssl.fastly.net/mfr/orig_boomver_2_G5101068-4.jpg",
      "https://bt-photos.global.ssl.fastly.net/mfr/orig_boomver_2_G5101068-5.jpg",
      "https://bt-photos.global.ssl.fastly.net/mfr/orig_boomver_2_G5101068-6.jpg",
      "https://bt-photos.global.ssl.fastly.net/mfr/orig_boomver_2_G5101068-7.jpg",
      "https://bt-photos.global.ssl.fastly.net/mfr/orig_boomver_2_G5101068-8.jpg",
      "https://bt-photos.global.ssl.fastly.net/mfr/orig_boomver_3_G5101068-9.jpg",
      "https://bt-photos.global.ssl.fastly.net/mfr/orig_boomver_2_G5101068-10.jpg",
      "https://bt-photos.global.ssl.fastly.net/mfr/orig_boomver_2_G5101068-11.jpg",
      "https://bt-photos.global.ssl.fastly.net/mfr/orig_boomver_2_G5101068-12.jpg",
      "https://bt-photos.global.ssl.fastly.net/mfr/orig_boomver_2_G5101068-13.jpg",
      "https://bt-photos.global.ssl.fastly.net/mfr/orig_boomver_2_G5101068-14.jpg",
      "https://bt-photos.global.ssl.fastly.net/mfr/orig_boomver_2_G5101068-15.jpg",
      "https://bt-photos.global.ssl.fastly.net/mfr/orig_boomver_2_G5101068-16.jpg",
      "https://bt-photos.global.ssl.fastly.net/mfr/orig_boomver_2_G5101068-17.jpg",
      "https://bt-photos.global.ssl.fastly.net/mfr/orig_boomver_2_G5101068-18.jpg",
      "https://bt-photos.global.ssl.fastly.net/mfr/orig_boomver_2_G5101068-19.jpg",
      "https://bt-photos.global.ssl.fastly.net/mfr/orig_boomver_2_G5101068-20.jpg",
      "https://bt-photos.global.ssl.fastly.net/mfr/orig_boomver_2_G5101068-21.jpg",
      "https://bt-photos.global.ssl.fastly.net/mfr/orig_boomver_2_G5101068-22.jpg",
      "https://bt-photos.global.ssl.fastly.net/mfr/orig_boomver_2_G5101068-23.jpg",
      "https://bt-photos.global.ssl.fastly.net/mfr/orig_boomver_2_G5101068-24.jpg",
      "https://bt-photos.global.ssl.fastly.net/mfr/orig_boomver_2_G5101068-25.jpg",
      "https://bt-photos.global.ssl.fastly.net/mfr/orig_boomver_2_G5101068-26.jpg",
      "https://bt-photos.global.ssl.fastly.net/mfr/orig_boomver_2_G5101068-27.jpg",
      "https://bt-photos.global.ssl.fastly.net/mfr/orig_boomver_2_G5101068-28.jpg",
      "https://bt-photos.global.ssl.fastly.net/mfr/orig_boomver_2_G5101068-29.jpg",
      "https://bt-photos.global.ssl.fastly.net/mfr/orig_boomver_2_G5101068-30.jpg",
      "https://bt-photos.global.ssl.fastly.net/mfr/orig_boomver_2_G5101068-31.jpg",
      "https://bt-photos.global.ssl.fastly.net/mfr/orig_boomver_2_G5101068-32.jpg",
      "https://bt-photos.global.ssl.fastly.net/mfr/orig_boomver_2_G5101068-33.jpg",
      "https://bt-photos.global.ssl.fastly.net/mfr/orig_boomver_2_G5101068-34.jpg",
      "https://bt-photos.global.ssl.fastly.net/mfr/orig_boomver_2_G5101068-35.jpg",
      "https://bt-photos.global.ssl.fastly.net/mfr/orig_boomver_2_G5101068-36.jpg",
      "https://bt-photos.global.ssl.fastly.net/mfr/orig_boomver_2_G5101068-37.jpg",
      "https://bt-photos.global.ssl.fastly.net/mfr/orig_boomver_2_G5101068-38.jpg",
      "https://bt-photos.global.ssl.fastly.net/mfr/orig_boomver_2_G5101068-39.jpg",
      "https://bt-photos.global.ssl.fastly.net/mfr/orig_boomver_2_G5101068-40.jpg",
      "https://bt-photos.global.ssl.fastly.net/mfr/orig_boomver_2_G5101068-41.jpg",
      "https://bt-photos.global.ssl.fastly.net/mfr/orig_boomver_2_G5101068-42.jpg",
      "https://bt-photos.global.ssl.fastly.net/mfr/orig_boomver_2_G5101068-43.jpg",
      "https://bt-photos.global.ssl.fastly.net/mfr/orig_boomver_2_G5101068-44.jpg",
      "https://bt-photos.global.ssl.fastly.net/mfr/orig_boomver_2_G5101068-45.jpg",
      "https://bt-photos.global.ssl.fastly.net/mfr/orig_boomver_2_G5101068-46.jpg",
      "https://bt-photos.global.ssl.fastly.net/mfr/orig_boomver_2_G5101068-47.jpg",
      "https://bt-photos.global.ssl.fastly.net/mfr/orig_boomver_2_G5101068-48.jpg",
      "https://bt-photos.global.ssl.fastly.net/mfr/orig_boomver_2_G5101068-49.jpg",
      "https://bt-photos.global.ssl.fastly.net/mfr/orig_boomver_2_G5101068-50.jpg",
      "https://bt-photos.global.ssl.fastly.net/mfr/orig_boomver_2_G5101068-51.jpg",
      "https://bt-photos.global.ssl.fastly.net/mfr/orig_boomver_2_G5101068-52.jpg",
      "https://bt-photos.global.ssl.fastly.net/mfr/orig_boomver_2_G5101068-53.jpg",
      "https://bt-photos.global.ssl.fastly.net/mfr/orig_boomver_2_G5101068-54.jpg",
      "https://bt-photos.global.ssl.fastly.net/mfr/orig_boomver_2_G5101068-55.jpg",
      "https://bt-photos.global.ssl.fastly.net/mfr/orig_boomver_2_G5101068-56.jpg",
      "https://bt-photos.global.ssl.fastly.net/mfr/orig_boomver_2_G5101068-57.jpg",
      "https://bt-photos.global.ssl.fastly.net/mfr/orig_boomver_2_G5101068-58.jpg",
      "https://bt-photos.global.ssl.fastly.net/mfr/orig_boomver_2_G5101068-59.jpg",
      "https://bt-photos.global.ssl.fastly.net/mfr/orig_boomver_2_G5101068-60.jpg",
      "https://bt-photos.global.ssl.fastly.net/mfr/orig_boomver_2_G5101068-61.jpg",
      // Images 62-74 REMOVED as requested
      // Images 75-85 (keeping these)
      "https://bt-photos.global.ssl.fastly.net/mfr/orig_boomver_2_G5101068-75.jpg",
      "https://bt-photos.global.ssl.fastly.net/mfr/orig_boomver_2_G5101068-76.jpg",
      "https://bt-photos.global.ssl.fastly.net/mfr/orig_boomver_2_G5101068-77.jpg",
      "https://bt-photos.global.ssl.fastly.net/mfr/orig_boomver_2_G5101068-78.jpg",
      "https://bt-photos.global.ssl.fastly.net/mfr/orig_boomver_2_G5101068-79.jpg",
      "https://bt-photos.global.ssl.fastly.net/mfr/orig_boomver_2_G5101068-80.jpg",
      "https://bt-photos.global.ssl.fastly.net/mfr/orig_boomver_2_G5101068-81.jpg",
      "https://bt-photos.global.ssl.fastly.net/mfr/orig_boomver_2_G5101068-82.jpg",
      "https://bt-photos.global.ssl.fastly.net/mfr/orig_boomver_2_G5101068-83.jpg",
      "https://bt-photos.global.ssl.fastly.net/mfr/orig_boomver_2_G5101068-84.jpg",
      "https://bt-photos.global.ssl.fastly.net/mfr/orig_boomver_2_G5101068-85.jpg"
    ]
  },
  
  // SEO Data
  seo: {
    title: "20-Acre Central Florida Legacy Estate | 35126 William Lane",
    description: "Private 20-acre gated Central Florida estate near Orlando with residence, workshops, vehicle lift, barn/pasture, business-support infrastructure and Florida resilience systems. Offered at $2.3M.",
    ogImage: "https://bt-photos.global.ssl.fastly.net/mfr/orig_boomver_3_G5101068-1.jpg"
  }
};

// Presentation slide images (converted from PowerPoint)
// PDF download available at /William-Lane-Estate-Presentation.pdf
export const presentationData = {
  pdfUrl: "/William-Lane-Estate-Presentation.pdf",
  totalSlides: 21,
  slideImages: [
    "/slides/slide-01.jpg",
    "/slides/slide-02.jpg",
    "/slides/slide-03.jpg",
    "/slides/slide-04.jpg",
    "/slides/slide-05.jpg",
    "/slides/slide-06.jpg",
    "/slides/slide-07.jpg",
    "/slides/slide-08.jpg",
    "/slides/slide-09.jpg",
    "/slides/slide-10.jpg",
    "/slides/slide-11.jpg",
    "/slides/slide-12.jpg",
    "/slides/slide-13.jpg",
    "/slides/slide-14.jpg",
    "/slides/slide-15.jpg",
    "/slides/slide-16.jpg",
    "/slides/slide-17.jpg",
    "/slides/slide-18.jpg",
    "/slides/slide-19.jpg",
    "/slides/slide-20.jpg",
    "/slides/slide-21.jpg"
  ]
};

// Presentation slides data (for text fallback)
export const presentationSlides = [
  {
    id: 1,
    title: "35126 William Lane",
    subtitle: "A Private Central Florida Legacy Estate",
    content: "Eustis, Florida 32736 · Offered at $2,300,000"
  },
  {
    id: 2,
    title: "Gateway Into Central Florida",
    content: "20 Private Acres • No HOA • Gated • County-Zoned • 45 minutes from Orlando International Airport"
  },
  {
    id: 3,
    title: "Nothing Comparable Exists",
    content: "Within 25–50 minutes of two major Florida airports. A rare Central Florida legacy estate — land, privacy, infrastructure, and multi-generational potential in a single acquisition."
  },
  {
    id: 4,
    title: "Immediate Comparison",
    content: "Research shows the closest active improved approx. 18–20-acre metro-area alternatives were approx.: $3.15-$3.3 Million. Current offering at $2.3M represents up to nearly $1 million below these alternatives."
  },
  {
    id: 5,
    title: "The Complete Value Stack",
    content: "Every asset category — already built, already delivered, included at one price. Land, residence, infrastructure, wellness amenities, and expansion rights."
  },
  {
    id: 6,
    title: "Land & Privacy",
    content: "20 acres, county-zoned, no HOA, ag-tax. Complete freedom. Land is finite near Orlando."
  },
  {
    id: 7,
    title: "The Main Residence",
    content: "4 Bed · 4 Bath · Two Full Kitchens. Multi-generational by design. Move-in ready. Premium mechanicals: Metal Roof · Tankless · Generator · Purified Well."
  },
  {
    id: 8,
    title: "Executive Workshop",
    content: "35'×48' with professional car lift, full bath, and office space. Built for collector, contractor, or entrepreneur. Business office away from house."
  },
  {
    id: 9,
    title: "Conditioned Steel Building",
    content: "56'×28' climate-controlled space with office and bath. Business HQ, creative studio, or guest quarters ready."
  },
  {
    id: 10,
    title: "Infrastructure Deep Dive",
    content: "True Operational Estate — Workshop, outbuildings, pasture, amenities built. Turnkey estate, not a future project."
  },
  {
    id: 11,
    title: "Equestrian & Hobby Farm",
    content: "Horse stalls and round pen. Three fenced pastures on ag-zoned land. Barn, chicken coops, and goat pens. Turnkey system designed for rotating livestock."
  },
  {
    id: 12,
    title: "Agricultural Tax Advantage",
    content: "Agriculturally zoned, delivering a meaningful annual tax benefit rarely available this close to a major Florida metro. A structural advantage that compounds over time."
  },
  {
    id: 13,
    title: "Wellness Amenities",
    content: "Standalone Cedar Sauna — Private spa amenity most estates only add later. Treehouse-Style Suite — Elevated guest retreat and private escape."
  },
  {
    id: 14,
    title: "What Makes This Estate Different",
    content: "Zero HOA Restrictions • Agricultural Tax Advantage • 20 Contiguous Usable Acres • Complete Infrastructure Already In Place"
  },
  {
    id: 15,
    title: "Location Intelligence",
    content: "~10 min: Historic Eustis • ~15 min: Mount Dora • ~25 min: Sanford Airport • ~45 min: Orlando International • ~45 min: Universal & SeaWorld"
  },
  {
    id: 16,
    title: "The True Price Analysis",
    content: "Price per sq ft of LAND: $2.58 • Infrastructure Value: $500K–$675K • Replacement Value: $2.7M–$3.2M minimum • Offered at $2.3M"
  },
  {
    id: 17,
    title: "Who This Estate Is For",
    content: "Out-of-State Relocation • Multi-Generational Family • Business Owner / Collector • Equestrian / Homesteader • Tax Advantage Seeker"
  },
  {
    id: 18,
    title: "Multi-Residence Potential",
    content: "Supports build rights at approximately one full residence per five acres. Subject to applicable Lake County approvals."
  },
  {
    id: 19,
    title: "Rare Relocation Opportunity",
    content: "75% of Orlando-region net migration during 2025 flowing toward Lake and Osceola Counties. The buyer pool is already arriving."
  },
  {
    id: 20,
    title: "The Opportunity Is Now",
    content: "The current list price is a floor, not a ceiling. The right client will want to be the one who saw it before that sentence becomes obvious to everyone else."
  },
  {
    id: 21,
    title: "Request Private Information",
    content: "Visit centralflorida20acres.estate to arrange a private viewing or live walkthrough. The estate is best understood in person."
  }
];

// Mock inquiries storage
export const mockInquiries = [];

export const addInquiry = (inquiry) => {
  const newInquiry = {
    id: Date.now(),
    ...inquiry,
    createdAt: new Date().toISOString()
  };
  mockInquiries.push(newInquiry);
  return newInquiry;
};
